import { render } from "./LinkColors.vue?vue&type=template&id=61fbb612&scoped=true"
import script from "./LinkColors.vue?vue&type=script&lang=js"
export * from "./LinkColors.vue?vue&type=script&lang=js"

import "./LinkColors.vue?vue&type=style&index=0&id=61fbb612&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61fbb612"]])

export default __exports__